import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const CwfDocumentRoute = LazyLoad(
  lazy(() => import('./cwf-document').then((module) => ({ default: module.CwfDocument }))),
);
